import { inputs } from "../../../../inputs/inputConfigs";

export default {
  groups: [
    {
      items: [
        { input: inputs.noteEmailSentBy, grid: { xs: 12 } },
        { input: inputs.noteEmailSentTo, grid: { xs: 12 } },
        { input: inputs.noteSubjectLine, grid: { xs: 12 } },
        { input: inputs.noteDetail, grid: { xs: 12 } },
        { input: inputs.noteTime, grid: { xs: 12 } },
      ],
    },
  ],
};
